import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { useMessageContext } from '../context/MessageContext';
import { connectNotifications } from '../Services/signalRService';

export default function NotificationComponent() {
  const { setNewIncomingMessage, setActiveConversationId } = useMessageContext();
  // Stable instance: changing the language must not reconnect the hub; the text is read when the event arrives.
  const { i18n } = useTranslation();
  useEffect(() => {
    let stop;
    const unsubscribe = onAuthStateChanged(auth, user => {
      stop?.();
      setNewIncomingMessage(null);
      setActiveConversationId(null);
      if (user) stop = connectNotifications(user, notification => {
        setNewIncomingMessage(notification);
        window.dispatchEvent(new CustomEvent('newMessage', { detail: notification }));
      }, () => window.dispatchEvent(new Event('messagesResumed')), ({ requestId }) => {
        // Light notice, no redirect and no listing or contact detail; "Mes recherches" refetches its counters.
        toast.info(i18n.t('propertyRequest.notify.proposal'), { toastId: `property-request-proposal-${requestId}` });
        window.dispatchEvent(new CustomEvent('propertyRequestProposal', { detail: { requestId } }));
      });
    });
    return () => { unsubscribe(); stop?.(); };
  }, [setNewIncomingMessage, setActiveConversationId, i18n]);
  return null;
}
